var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-bespoke-v2"},[_c('appointment-wizard',{attrs:{"default-purpose":_vm.defaultPurpose,"default-country":_vm.defaultCountry}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }